export function getLinkTextVivaEngage() {
  switch (document.documentElement.lang) {
    case "fr":
      return "Groupe Viva Engage eGPL 2";
    case "it":
      return "Gruppo Viva Engage eGPL 2";
    case "en":
      return "Viva Engage group eGPL 2";
    default:
      return "Viva Engage Gruppe eGPL 2";
  }
}

export function getLinkTextSupport() {
  switch (document.documentElement.lang) {
    case "fr":
      return "Support";
    case "it":
      return "Supporto";
    case "en":
      return "Support";
    default:
      return "Support";
  }
}

export function getLinkTextKnowHow() {
  switch (document.documentElement.lang) {
    case "en":
      return "Know-how articles";
    case "fr":
      return "Articles de savoir-faire";
    case "it":
      return "Articoli di know-how";
    default:
      return "Know-How Artikel";
  }
}

export function getLinkTextManual() {
  switch (document.documentElement.lang) {
    case "en":
      return "Manuals";
    case "fr":
      return "Manuels";
    case "it":
      return "Manuali";
    default:
      return "Anleitungen";
  }
}

export function getHeadingImprint() {
  return window.labels.Footer_Imprint;
}

export function getHeadingHelp() {
  return window.labels.Help;
}

export function getHeadingSupport() {
  switch (document.documentElement.lang) {
    case "en":
      return "Support";
    case "fr":
      return "Support";
    case "it":
      return "Supporto";
    default:
      return "Support";
  }
}
export function getLinkTextCosProducts() {
  switch (document.documentElement.lang) {
    case "en":
      return "COS product eGPL 2";
    case "fr":
      return "Produit COS eGPL 2";
    case "it":
      return "Prodotto COS eGPL 2";
    default:
      return "COS-Produkt eGPL 2";
  }
}
